export default {
    button: {
        margin: 4,
    },
};
